import a from "react";
import { useTheme as B, Select as O } from "@mui/material";
import W from "@mui/material/InputLabel";
import F from "@mui/material/FormControl";
import M from "@mui/material/FormHelperText";
import { M as A } from "./chunk.DVkl1685.js";
function H(e) {
  var r, i, d, o, u, m, c, f, h, b, v, y;
  const l = B(), E = (t) => {
    var s;
    const { menuItems: S, multiple: C } = e;
    return Array.isArray(t) && C ? t.map(($) => {
      const n = S.find(
        (q) => q.value === $
      );
      return n == null ? void 0 : n.label;
    }).filter(Boolean).join(", ") : (s = S.find((x) => t === x.value)) == null ? void 0 : s.label;
  }, g = (t) => () => {
    t === e.value && e.onChange({ target: { value: "" } });
  }, T = {
    ...e
  }, k = (d = (i = (r = l.components) == null ? void 0 : r.Select) == null ? void 0 : i.styleOverrides) != null && d.root && typeof ((m = (u = (o = l.components) == null ? void 0 : o.Select) == null ? void 0 : u.styleOverrides) == null ? void 0 : m.root) == "function" ? (h = (f = (c = l.components) == null ? void 0 : c.Select) == null ? void 0 : f.styleOverrides) == null ? void 0 : h.root({ ownerState: T, theme: l }) : (y = (v = (b = l.components) == null ? void 0 : b.Select) == null ? void 0 : v.styleOverrides) == null ? void 0 : y.root;
  return /* @__PURE__ */ a.createElement(F, { fullWidth: e.fullWidth, sx: { ...k } }, /* @__PURE__ */ a.createElement(
    W,
    {
      id: `${e.id}-label`,
      error: e.error,
      disabled: e.disabled,
      required: e.required
    },
    e.label
  ), /* @__PURE__ */ a.createElement(
    O,
    {
      id: e.id,
      labelId: `${e.id}-label`,
      value: e.value,
      error: e.error,
      required: e.required,
      disabled: e.disabled,
      onChange: e.onChange,
      onBlur: e.onBlur,
      renderValue: E,
      fullWidth: e.fullWidth,
      inputProps: {
        "data-testid": `${e.id}-input`
      },
      MenuProps: {
        "data-testid": `${e.id}-menu`,
        // Specifies how close to the edge of the window the menu/popover can appear; defaults to 16px if null
        marginThreshold: l.typography.htmlFontSize
      },
      multiple: e.multiple
    },
    e.menuItems.map((t) => /* @__PURE__ */ a.createElement(
      A,
      {
        key: t.value,
        variant: e.multiple ? "checkbox" : "checkmark",
        value: t.value,
        label: t.label,
        startElement: t.startElement,
        endText: t.endText,
        "data-testid": t["data-testid"],
        onClick: e.multiple ? void 0 : g(t.value)
      }
    ))
  ), e.helperText && /* @__PURE__ */ a.createElement(
    M,
    {
      component: "label",
      error: e.error,
      disabled: e.disabled,
      "data-testid": `${e.id}-helper-text`
    },
    e.helperText
  ));
}
export {
  H as S
};
